import React from 'react';
import LinkElement from './Link';
import BoxElement from './Box';
var InfoElement = function (_a) {
    var inlineContent = _a.inlineContent, isInline = _a.isInline, onClick = _a.onClick;
    return isInline ? (React.createElement(LinkElement, { onClick: onClick }, inlineContent)) : (React.createElement(BoxElement, { onClick: onClick }));
};
export default InfoElement;
//# sourceMappingURL=index.js.map